"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const AdminOnly_1 = require("../../../../comps/reusables/AdminOnly");
const IntegrationSharedSettings_1 = require("../IntegrationSharedSettings");
const ApiCredentialsCard_1 = require("../ApiCredentialsCard");
const timezone_1 = require("../timezone");
exports.ActiveCampaignSettings = ({ integration }) => {
    return (react_1.default.createElement(reusables_1.Form, { mutationProps: {
            mutation: graphql_1.updateActiveCampaign,
            refetchQueries: [
                {
                    query: graphql_1.integration,
                    variables: {
                        id: integration.id,
                    },
                },
            ],
        }, valuesToVariables: values => {
            var _a, _b, _c, _d, _e, _f;
            return {
                data: {
                    activeCampaignApiUrl: (_a = values.activeCampaignApiUrl) === null || _a === void 0 ? void 0 : _a.trim(),
                    activeCampaignWorkspaceUrl: (_b = values.activeCampaignWorkspaceUrl) === null || _b === void 0 ? void 0 : _b.trim(),
                    apiSecretKey: (_c = values.apiSecretKey) === null || _c === void 0 ? void 0 : _c.trim(),
                    integrationTimezone: typeof values.integrationTimezone === 'object' && ((_d = values.integrationTimezone) === null || _d === void 0 ? void 0 : _d.value)
                        ? (_e = values.integrationTimezone) === null || _e === void 0 ? void 0 : _e.value : null,
                    name: (_f = values.name) === null || _f === void 0 ? void 0 : _f.trim(),
                },
                id: integration.id,
            };
        }, formikProps: {
            initialValues: {
                activeCampaignApiUrl: integration.activeCampaignApiUrl,
                activeCampaignWorkspaceUrl: integration.activeCampaignWorkspaceUrl,
                apiSecretKey: integration.apiSecretKey,
                integrationTimezone: timezone_1.findTimezoneOption(integration.integrationTimezone),
                name: integration.name,
            },
            validationSchema: () => Yup.object().shape({
                name: Yup.string()
                    .trim()
                    .required('Required'),
            }),
        }, showBottomToolbar: true }, formikProps => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IntegrationSharedSettings_1.IntegrationSharedSettings, { integration: integration, formikProps: formikProps, sidebar: react_1.default.createElement(ApiCredentialsCard_1.ApiCredentialsCard, null,
                react_1.default.createElement(reusables_1.FormGroup, { label: "Active Campaign workspace URL", placeholder: "https://companyname.activehosted.com", name: "activeCampaignWorkspaceUrl", autoComplete: "off" }),
                react_1.default.createElement(reusables_1.FormGroup, { label: "Active Campaign API URL", placeholder: "https://companyname.api-us1.com", name: "activeCampaignApiUrl", autoComplete: "off" }),
                react_1.default.createElement(reusables_1.FormGroup, { label: "API secret key", name: "apiSecretKey", autoComplete: "off" }),
                react_1.default.createElement(AdminOnly_1.AdminOnly, null,
                    react_1.default.createElement(reusables_1.FormGroup, { label: "Integration timezone", name: "integrationTimezone", options: timezone_1.TIMEZONE_OPTIONS, type: "select", selectProps: {
                            isClearable: true,
                        } }))) })))));
};
//# sourceMappingURL=ActiveCampaignSettings.js.map